import * as I18n from 'circe/I18n';
import { NAME as FUSE_NAME } from '../constants';

export const NAME = `${FUSE_NAME}/MAPS`;
export const REDUCER_NAME = 'maps';
